<template>
   <common-form
      form-title="Physical Information"
      :back-route="this.backRoute"
      :errors="errors.non_field_errors"
      @submit="save"
      @save-and-continue="saveAndContinue"
   >
      <atom-button label="Calculate Settlement" @click="calculateSettlement"/>
      <input-field v-model="form.settlements" type="number" label="Settlements" :errors="errors.settlements" required/>
      <div>
         <div>Institutions</div>
         <small>Edit the number column in the table as necessary</small>
         <!-- <errors :errors="wardOfficerErrors"/> -->
         <vue-editable-grid
            :column-defs="[
               { sortable: true, field: 'institution_type', headerName: 'Insitution Type', editable: false },
               { sortable: true, field: 'category',         headerName: 'Category',        editable: false },
               { sortable: true, field: 'number',           headerName: 'Number',          editable: true },
            ]"
            :key="institutions.length"
            :row-data="institutions"
            row-data-key="index"
            :enable-filters="false"
            :item-height="35"
         />
      </div>
      <!--
         <input-field v-model="form.school" type="number" label="School" :errors="errors.school" required/>
         <input-field v-model="form.college" type="number" label="College" :errors="errors.college" required/>
         <input-field v-model="form.health_facility" type="number" label="Health facility" :errors="errors.health_facility" required/>
         <input-field v-model="form.bank" type="number" label="Bank" :errors="errors.bank" required/>
      -->
</common-form>
</template>

<script>
import AtomButton from '@/components/atoms/Login/Button';
import CommonForm from '@/components/organisms/Home/Plan/Form'
import InputField from '@/components/molecules/Login/InputField';
import FormMixin from '@/mixins/planform';
import { fetchWithAuthToken, postWithAuthToken } from '@/axios';
import { showSuccess,showError } from '@/js/ui-helpers';

export default {
   name: 'physical-info-form',
   components: {
      InputField,
      CommonForm,
      AtomButton,
   },
   data()
   {
      const form = {
         settlements: null,
         // school: null,
         // college: null,
         // health_facility: null,
         // bank: null,
      };
      return {
         form,
         institutions: [],
         errors: this.getDefaultErrors(form),
         backRoute: {name: 'edit-renewable-energy-info',params: {id: this.getPlanId()}},
         nextRoute: {name: 'edit-land-cover-info',params: {id: this.getPlanId()}},
      };
   },
   mixins: [FormMixin],
   created() {
      fetchWithAuthToken(this.institutionUrl)
         .then(({data}) => this.institutions = data);
   },
   computed: {
      institutionUrl() {
         return`api/plan/${this.getPlanId()}/institutions`;
      },
      url()
      {
         const planId = this.$route.params.id;
         return `api/plan/${planId}/physical-info`;
      },
      notificationTitle()
      {
         return "Physical Information";
      },
      successMessage()
      {
         return "Successfully edited physical information"; 
      },
      errorMessage()
      {
         return "Editing physical information was unsuccessful";
      },
   },
   methods: {
      calculateSettlement() {
         fetchWithAuthToken(`/api/plan/calculate-settlements/?plan_id=${this.getPlanId()}`)
         .then(({data}) => {this.form.settlements=data})
      },
      async save(formElement, {goToNextStep=false}={})
      {
         this.resetErrors();
         if (!formElement.checkValidity())
         {
            formElement.reportValidity();
            return;
         }
         try
         {
            const results = await postWithAuthToken(this.url, this.form, {method: 'put'}, {raise404: true})
            const institutionResults = await postWithAuthToken(this.institutionUrl, this.institutions, {raise404: true});
            if (results && institutionResults)
            {
               if (goToNextStep)
               {
                  this.$router.push(this.nextRoute);
               }
               showSuccess(this.notificationTitle, this.successMessage);
            }
         }
         catch (error)
         {
            console.log(error.response.data);
            showError(this.notificationTitle, this.errorMessage)
            const errors = error.response && error.response.data;
            if (errors)
            {
               this.updateErrors(errors);
            }
            else
            {
               console.error(error, error.response, errors);
            }
         }
      },
   },
}
</script>
